import { render, staticRenderFns } from "./BpaC.vue?vue&type=template&id=199eb9d4"
import script from "./BpaC.vue?vue&type=script&lang=js"
export * from "./BpaC.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports